module.exports = __webpack_public_path__ + "img/BACKUP.d8b8ac12.svg";